<dx-popup
    #applyDebitLineItemEditorPopup
    minWidth="150px"
    minHeight="100px"
    width="70%"
    height="65%"
    title="Specify Apply Amount For Each Line Items"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-data-grid
                        height="100%"
                        allowColumnResizing="true"
                        class="grid-bottom-padding"
                        [dataSource]="sourceLineInfo"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                    >
                        <dxi-column dataType="number" dataField="line" caption="Line #"></dxi-column>
                        <dxi-column
                            dataType="number"
                            dataField="amount"
                            caption="Amount"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column
                            dataType="number"
                            dataField="appliedAmount"
                            caption="Applied Amount"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column
                            dataType="number"
                            dataField="remainingUnapplied"
                            caption="Remaining Unapplied"
                            [format]="currencyFormat"
                        ></dxi-column>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        keyExpr="itemId"
                        class="grid-bottom-padding"
                        [highlightChanges]="true"
                        [repaintChangesOnly]="true"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [dataSource]="sourceLineItems"
                    >
                        <dxi-column
                            dataType="number"
                            caption="Item #"
                            cellTemplate="itemNumber"
                            [allowEditing]="false"
                        ></dxi-column>

                        <dxi-column
                            dataType="number"
                            dataField="amount"
                            caption="Amount"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column dataType="string" dataField="glAccountNumber" caption="GL Account"></dxi-column>
                        <dxi-column
                            dataType="string"
                            dataField="offsetGLAccountNumber"
                            caption="Offset GL Account"
                        ></dxi-column>
                        <dxi-column
                            dataType="string"
                            caption="Dim/Option Code"
                            cellTemplate="dimensionOptionCellTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let item of 'itemNumber'">
                            {{ getItemLabel(item) }}
                        </div>

                        <div *dxTemplate="let d of 'dimensionOptionCellTemplate'">
                            <div *ngFor="let dim of d.data.dimensions">
                                <strong>{{ dim.dimensionCode }}:</strong>
                                {{ dim.dimensionOptionCode }}
                            </div>
                        </div>

                        <dxo-master-detail [enabled]="true" template="target"></dxo-master-detail>
                        <div *dxTemplate="let item of 'target'">
                            <div class="cc-text-bold">Target Line Items</div>
                            <div class="grid-bottom-padding">
                                <dx-data-grid
                                    #targetTransactionGrid
                                    width="100%"
                                    height="100%"
                                    [keyExpr]="['sourceItemId', 'itemId']"
                                    class="grid-bottom-padding"
                                    [highlightChanges]="true"
                                    [repaintChangesOnly]="true"
                                    [allowColumnReordering]="true"
                                    [allowColumnResizing]="true"
                                    [showBorders]="true"
                                    [showColumnLines]="true"
                                    [showRowLines]="true"
                                    [dataSource]="item.data.targetItems"
                                    (onRowUpdated)="onRowUpdated($event)"
                                >
                                    <dxo-selection
                                        showCheckBoxesMode="always"
                                        mode="multiple"
                                        [allowSelectAll]="false"
                                    ></dxo-selection>
                                    <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                                    <dxo-pager [visible]="false"></dxo-pager>
                                    <dxo-paging [enabled]="false"></dxo-paging>

                                    <dxi-column
                                        dataType="number"
                                        dataField="appliedAmount"
                                        caption="Apply Amount"
                                        [format]="currencyFormat"
                                        [allowSorting]="false"
                                        [allowFiltering]="false"
                                    ></dxi-column>

                                    <dxi-column
                                        dataType="number"
                                        dataField="amount"
                                        caption="Amount"
                                        [format]="currenctFormat"
                                        [allowEditing]="false"
                                    ></dxi-column>
                                    <dxi-column
                                        dataType="string"
                                        dataField="openBalance"
                                        caption="Open Balance"
                                        [format]="currenctFormat"
                                        [allowEditing]="false"
                                    ></dxi-column>

                                    <dxi-column
                                        dataType="string"
                                        dataField="glAccountNumber"
                                        caption="GL Account"
                                    ></dxi-column>
                                    <dxi-column
                                        dataType="string"
                                        dataField="offsetGLAccountNumber"
                                        caption="Offset GL Account"
                                    ></dxi-column>
                                    <dxi-column
                                        dataType="string"
                                        caption="Dim/Option Code"
                                        cellTemplate="dimensionOptionCellTemplate"
                                    ></dxi-column>
                                    <div *dxTemplate="let d of 'dimensionOptionCellTemplate'">
                                        <div *ngFor="let dim of d.data.dimensions">
                                            <strong>{{ dim.dimensionCode }}:</strong>
                                            {{ dim.dimensionOptionCode }}
                                        </div>
                                    </div>
                                </dx-data-grid>
                            </div>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <div class="left-content">
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                        <div class="right-content">
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #applyDebitMessageBox></cc-message-box>
